import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    box: {
        maxHeight: '30px',
        minHeight: '30px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
    select: {
        minWidth: 50,
        maxWidth: 300,
        width: '100%',
        textOverflow: 'ellipsis',
        height: 30,
      },
    button: {
        padding: '0.3rem 1rem',
        fontSize: '12px',
    },
    textfield: {
        minWidth: 50,
        maxWidth: 300,
        width: '100%',
        height: 30,
    },
    flexBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent:'flex-end',
      },

}));

export default useStyles;
